module.exports = __webpack_public_path__ + "images/Corvus_Pharma-077182.png";